// extracted by mini-css-extract-plugin
module.exports = {"pill":"pill_pill__Sewmt","grass":"pill_grass__3JXc_","cheddar":"pill_cheddar__2J6A6","cement":"pill_cement__JMw7B","deepRed":"pill_deepRed__2BNYK","sky":"pill_sky__1zZ23"};